import { OneDecimalPlace, TwoDecimalPlace } from '../../../helpers/Helpers';

export const totalWeeksOfSelectedQuarter = (colArr, quarterIdx: number): number => {
  return colArr[quarterIdx].months.reduce((acc, month) => {
    acc += month.weeks.length;
    return acc;
  }, 0) + 1;
};

export const calculateEachProductTotal = (quarters, measureName: string) => {
  const total = quarters.reduce((qInit, quarter) => {
    qInit += quarter.value;
    return qInit;
  }, 0);

  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : TwoDecimalPlace(total);
};

export const calculateProductTotal = (rowArr, mIdx: number, pIdx: number, measureName: string): number => {
  if (measureName === 'Plan ASP') {
    const unitIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - UNITS');
    const valueIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const totalUnit = calculateEachProductTotal(rowArr[unitIdx].products[pIdx].quarters, 'Plan / Quota - UNITS');
    const totalValue = calculateEachProductTotal(rowArr[valueIdx].products[pIdx].quarters, 'Plan / Quota - $');

    return totalUnit !== 0 ? TwoDecimalPlace(totalValue / totalUnit) : 0;
  }

  if (measureName === 'Margin %') {
    const planQuotaIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'Margin $');
    const totalPlanQuota = calculateEachProductTotal(rowArr[planQuotaIdx].products[pIdx].quarters, 'Plan / Quota - $');
    let totalMargin;

    if (rowArr[marginIdx].products[pIdx]) {
      totalMargin = calculateEachProductTotal(rowArr[marginIdx].products[pIdx].quarters, 'Margin $');
    }

    return totalPlanQuota !== 0 ? OneDecimalPlace((totalMargin / totalPlanQuota) * 100) : 0;
  }

  return calculateEachProductTotal(rowArr[mIdx].products[pIdx].quarters, measureName);
};

export const calculateMeasureTotal = (products, measureName: string): number => {
  const total = products
    .filter((product, idx) => products.length - 1 !== idx)
    .reduce((pInit, product) => {
      pInit += calculateEachProductTotal(product.quarters, measureName);
      return pInit;
    }, 0);

  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : TwoDecimalPlace(total);
};

export const calculateMeasurePct = (products, measureName: string): number => {
  const total = products
    .reduce((pInit, product) => {
      pInit += calculateEachProductTotal(product.quarters, measureName);
      return pInit;
    }, 0);

  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : TwoDecimalPlace(total);
};

export const calculateQuarterValue = (rowArr, mIdx: number, pIdx: number, qIdx: number, measureName: string): number => {
  if (measureName === 'Plan ASP') {
    const unitIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - UNITS');
    const valueIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const totalUnit = Math.round(rowArr[unitIdx].products[pIdx].quarters[qIdx].value);
    const totalValue = rowArr[valueIdx].products[pIdx].quarters[qIdx].value;

    return totalUnit !== 0 ? TwoDecimalPlace(totalValue / totalUnit) : 0;
  }

  if (measureName === 'Margin %') {
    const planQuotaIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'Margin $');
    const totalPlanQuota = rowArr[planQuotaIdx].products[pIdx].quarters[qIdx].value;
    const totalMargin = rowArr[marginIdx].products[pIdx].quarters[qIdx].value;

    return totalPlanQuota !== 0 ? OneDecimalPlace((totalMargin / totalPlanQuota) * 100) : 0;
  }

  const total = rowArr[mIdx].products[pIdx].quarters[qIdx].value;
  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : TwoDecimalPlace(total);
};

export const calculateMeasureAverage = (rowArr, measureName: string): number => {
  if (measureName === 'Plan ASP') {
    const unitIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - UNITS');
    const valueIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const totalUnit = calculateMeasureTotal(rowArr[unitIdx].products, 'Plan / Quota - UNITS');
    const totalValue = calculateMeasureTotal(rowArr[valueIdx].products, 'Plan / Quota - $');

    return totalUnit !== 0 ? TwoDecimalPlace(totalValue / totalUnit) : 0;
  }

  if (measureName === 'Margin %') {
    const planQuotaIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'Margin $');
    const totalPlanQuota = calculateMeasureTotal(rowArr[planQuotaIdx].products, 'Plan / Quota - $');
    const totalMargin = calculateMeasurePct(rowArr[marginIdx].products, 'Margin $');

    return totalPlanQuota !== 0 ? OneDecimalPlace((totalMargin / totalPlanQuota) * 100) : 0;
  }

  return 0;
};

export const calculateQuarterTotal = (products, qIdx: number, measureName: string): number => {
  const total = products
    .filter((product, idx) => products.length - 1 !== idx)
    .reduce((pInit, product) => {
      pInit += product.quarters[qIdx].value;
      return pInit;
    }, 0);

  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : TwoDecimalPlace(total);
};

export const calculateQuarterPct = (products, qIdx: number, measureName: string): number => {
  const total = products
    .reduce((pInit, product) => {
      pInit += product.quarters[qIdx].weeks.reduce((wInit, week) => {
        wInit += week.value;
        return wInit;
      }, 0);
      return pInit;
    }, 0);

  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : TwoDecimalPlace(total);
};

export const calculateQuarterTotalForEachMeasure = (
  rowArr,
  mIdx: number,
  pIdx: number,
  qIdx: number,
  measureName: string
): number => {
  if (measureName === 'Plan ASP') {
    const unitIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - UNITS');
    const valueIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const totalUnit = calculateQuarterTotal(rowArr[unitIdx].products, qIdx, 'Plan / Quota - UNITS');
    const totalValue = calculateQuarterTotal(rowArr[valueIdx].products, qIdx, 'Plan / Quota - $');

    return TwoDecimalPlace(totalValue / totalUnit);
  }

  if (measureName === 'Margin %') {
    const planQuotaIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'Margin $');
    const totalPlanQuota = calculateQuarterTotal(rowArr[planQuotaIdx].products, qIdx, 'Plan / Quota - $');
    const totalMargin = calculateQuarterPct(rowArr[marginIdx].products, qIdx, 'Margin $');

    return OneDecimalPlace((totalMargin / totalPlanQuota) * 100);
  }

  return calculateQuarterTotal(rowArr[mIdx].products, qIdx, measureName);
};

export const calculateVerticalWeekTotal = (products, qIdx: number, wIdx: number, measureName: string): number => {
  const total = products
    .filter((product, idx) => products.length - 1 !== idx)
    .reduce((pInit, product) => {
      pInit += product.quarters[qIdx].weeks[wIdx].value;
      return pInit;
    }, 0);

  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : TwoDecimalPlace(total);
};

export const calculateHorizontalWeekTotal = (weeks, measureName: string): number => {
  const total = weeks.reduce((wInit, week) => {
    wInit += week.value;
    return wInit;
  }, 0);

  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : TwoDecimalPlace(total);
};

export const calculateWeekPct = (products, qIdx: number, wIdx: number, measureName: string): number => {
  const total = products
    .reduce((pInit, product) => {
      pInit += product.quarters[qIdx].weeks[wIdx].value;
      return pInit;
    }, 0);

  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : TwoDecimalPlace(total);
};

export const calculateWeekTotalForEachMeasure = (rowArr, mIdx: number, pIdx: number, qIdx: number, wIdx: number, measureName: string): number => {
  if (measureName === 'Plan ASP') {
    const unitIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - UNITS');
    const valueIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const totalUnit = calculateVerticalWeekTotal(rowArr[unitIdx].products, qIdx, wIdx, 'Plan / Quota - UNITS');
    const totalValue = calculateVerticalWeekTotal(rowArr[valueIdx].products, qIdx, wIdx, 'Plan / Quota - $');

    return totalUnit !== 0 ? TwoDecimalPlace(totalValue / totalUnit) : 0;
  }

  if (measureName === 'Margin %') {
    const planQuotaIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'Margin $');
    const totalPlanQuota = calculateVerticalWeekTotal(rowArr[planQuotaIdx].products, qIdx, wIdx, 'Plan / Quota - $');
    const totalMargin = calculateWeekPct(rowArr[marginIdx].products, qIdx, wIdx, 'Margin $');

    return totalPlanQuota !== 0 ? OneDecimalPlace((totalMargin / totalPlanQuota) * 100) : 0;
  }

  const total = calculateVerticalWeekTotal(rowArr[mIdx].products, qIdx, wIdx, measureName);
  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : TwoDecimalPlace(total);
};

export const calculateWeekValue = (rowArr, mIdx: number, pIdx: number, qIdx: number, wIdx: number, measureName: string): number => {
  if (measureName === 'Plan ASP') {
    const unitIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - UNITS');
    const valueIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const totalUnit = rowArr[unitIdx].products[pIdx].quarters[qIdx].weeks[wIdx].value;
    const totalValue = rowArr[valueIdx].products[pIdx].quarters[qIdx].weeks[wIdx].value;

    return totalUnit !== 0 ? TwoDecimalPlace(totalValue / totalUnit) : 0;
  }

  if (measureName === 'Margin %') {
    const planQuotaIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'Margin $');
    const totalPlanQuota = rowArr[planQuotaIdx].products[pIdx].quarters[qIdx].weeks[wIdx].value;
    const totalMargin = rowArr[marginIdx].products[pIdx].quarters[qIdx].weeks[wIdx].value;

    return totalPlanQuota !== 0 ? OneDecimalPlace((totalMargin / totalPlanQuota) * 100) : 0;
  }

  const total = rowArr[mIdx].products[pIdx].quarters[qIdx].weeks[wIdx].value;
  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : TwoDecimalPlace(total);
};

export const calculateCMWeekTotalForEachMeasure = (rowArr, rIdx: number, qIdx: number, wIdx: number, type: string, measureName: string): number => {
  if (measureName === 'Plan ASP') {
    const unitIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - UNITS');
    const valueIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const totalUnit = calculateVerticalCMWeekTotal(rowArr, unitIdx, qIdx, wIdx, type);
    const totalValue = calculateVerticalCMWeekTotal(rowArr, valueIdx, qIdx, wIdx, type);

    return totalUnit !== 0 ? TwoDecimalPlace(totalValue / totalUnit) : 0;
  }

  if (measureName === 'Margin %') {
    const planQuotaIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'Margin $');
    const totalPlanQuota = calculateVerticalCMWeekTotal(rowArr, planQuotaIdx, qIdx, wIdx, type);
    const totalMargin = calculateVerticalCMWeekTotal(rowArr, marginIdx, qIdx, wIdx, type);

    return totalPlanQuota !== 0 ? OneDecimalPlace((totalMargin / totalPlanQuota) * 100) : 0;
  }

  return calculateVerticalCMWeekTotal(rowArr, rIdx, qIdx, wIdx, type);
};

export const calculateVerticalCMWeekTotal = (rowArr, rIdx: number, qIdx: number, wIdx: number, type: string): number => {
  const total = rowArr[rIdx].products
    .filter((product, idx) => rowArr[rIdx].products.length - 1 !== idx)
    .reduce((pInit, product) => {
      pInit += product.quarters[qIdx].weeks[wIdx][type];
      return pInit;
    }, 0);

  return TwoDecimalPlace(total);
};

export const calculateCMQuarter = (weeks, type: string): number => {
  const total = weeks.reduce((wInit, week) => {
    wInit += week[type];
    return wInit;
  }, 0);

  return TwoDecimalPlace(total);
};

export const calculateCMQuarterTotalForEachMeasure = (rowArr, rIdx: number, qIdx: number, type: string, measureName: string): number => {
  if (measureName === 'Plan ASP') {
    const unitIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - UNITS');
    const valueIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const totalUnit = calculateVerticalCMQuarterTotal(rowArr, unitIdx, qIdx, type);
    const totalValue = calculateVerticalCMQuarterTotal(rowArr, valueIdx, qIdx, type);

    return totalUnit !== 0 ? TwoDecimalPlace(totalValue / totalUnit) : 0;
  }

  if (measureName === 'Margin %') {
    const planQuotaIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'Margin $');
    const totalPlanQuota = calculateVerticalCMQuarterTotal(rowArr, planQuotaIdx, qIdx, type);
    const totalMargin = calculateVerticalCMQuarterTotal(rowArr, marginIdx, qIdx, type);

    return totalPlanQuota !== 0 ? OneDecimalPlace((totalMargin / totalPlanQuota) * 100) : 0;
  }

  return calculateVerticalCMQuarterTotal(rowArr, rIdx, qIdx, type);
};

export const calculateVerticalCMQuarterTotal = (rowArr, rIdx: number, qIdx: number, type: string): number => {
  const total = rowArr[rIdx].products
    .filter((product, idx) => rowArr[rIdx].products.length - 1 !== idx)
    .reduce((pInit, product) => {
      pInit += calculateCMQuarter(product.quarters[qIdx].weeks, type);
      return pInit;
    }, 0);

  return TwoDecimalPlace(total);
};

export const calculateCMProduct = (rowArr, rIdx: number, pIdx: number, type: string): number => {
  const total = rowArr[rIdx].products[pIdx].quarters.reduce((qInit, quarter) => {
    qInit += calculateCMQuarter(quarter.weeks, type);
    return qInit;
  }, 0);

  return TwoDecimalPlace(total);
};

export const calculateCMProductTotalForEachMeasure = (rowArr, rIdx: number, pIdx: number, type: string, measureName: string): number => {
  if (measureName === 'Plan ASP') {
    const unitIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - UNITS');
    const valueIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const totalUnit = calculateVerticalCMProductTotal(rowArr, unitIdx, pIdx, type);
    const totalValue = calculateVerticalCMProductTotal(rowArr, valueIdx, pIdx, type);

    return totalUnit !== 0 ? TwoDecimalPlace(totalValue / totalUnit) : 0;
  }

  if (measureName === 'Margin %') {
    const planQuotaIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'Margin $');
    const totalPlanQuota = calculateVerticalCMProductTotal(rowArr, planQuotaIdx, pIdx, type);
    const totalMargin = calculateVerticalCMProductTotal(rowArr, marginIdx, pIdx, type);

    return totalPlanQuota !== 0 ? OneDecimalPlace((totalMargin / totalPlanQuota) * 100) : 0;
  }

  return calculateVerticalCMProductTotal(rowArr, rIdx, pIdx, type);
};

export const calculateVerticalCMProductTotal = (rowArr, rIdx: number, pIdx: number, type: string): number => {
  const total = rowArr[rIdx].products
    .filter((product, idx) => rowArr[rIdx].products.length - 1 !== idx)
    .reduce((pInit, product, productIdx) => {
      pInit += calculateCMProduct(rowArr, rIdx, productIdx, type);
      return pInit;
    }, 0);

  return TwoDecimalPlace(total);
};

export const checkIfAllQuartersArePast = (quarters): boolean => {
  return quarters.reduce((acc, value) => acc && value.isPast, true);
};
